import React from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';
import type { Theme } from 'src/theme';

interface CTAProps {
  className?: string;
  executeScroll: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 50,
    paddingBottom: 50
  },
  browseButton: {
    marginLeft: theme.spacing(2)
  }
}));

const CTA: FC<CTAProps> = ({ className, executeScroll, ...rest }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          align="left"
          color="textSecondary"
          style={{ fontWeight: 'bold'}}
        >
          Version 2.0 is in Beta
        </Typography>
        <Typography
          variant="body1"
          align="left"
          color="textSecondary"
          style={{ marginTop: 20 , fontFamily: 'Poppins' }}
        >
          Helping people have freedom from loans faster has been our mission for almost a decade. Our <a href='http://www.myliberte.com' target='_blank'>earlier platform</a> helped our users become smart payers, shortening the time to pay loans while paying less. But this mission is still growing and we’re excited to have more people take this journey with us so we’re rolling out a newer and improved version. You can still <b onClick={executeScroll} style={{ cursor: 'pointer' }}>get early access</b> today! <b onClick={executeScroll} style={{ cursor: 'pointer' }}>Get started</b> by following the steps to create your own account.
        </Typography>
      </Container>
    </div>
  );
};

CTA.propTypes = {
  className: PropTypes.string
};

export default CTA;
